// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"420c6862","232":"6fc61746","237":"f4493f0d","526":"c4cd8761","787":"22a8f6a3"}[chunkId] + ".chunk.js";
};